import type { QRCodeToDataURLOptions as QrCodeToDataURLOptions } from 'qrcode'
import { isRecordUnknown } from '@/utils/typeGuards'

export const W_QRCODE_TO_DATA_URL_MSG = 'W_QRCODE_TO_DATA_URL' as const
export type WorkerQrCodeToDataUrlPayload = {
  nonce: number
  type: typeof W_QRCODE_TO_DATA_URL_MSG
  text: string
  options?: QrCodeToDataURLOptions
}
export const isWorkerQrCodeToDataUrlPayload = (payload: unknown): payload is WorkerQrCodeToDataUrlPayload => {
  return isRecordUnknown(payload) && payload.type === W_QRCODE_TO_DATA_URL_MSG
}

export const W_QRCODE_TO_DATA_URL_SUCCESS_MSG = 'W_QRCODE_TO_DATA_URL_SUCCESS' as const
export type WorkerQrCodeToDataUrlPayloadSuccessPayload = {
  nonce: number
  type: typeof W_QRCODE_TO_DATA_URL_SUCCESS_MSG
  dataUrl: string
}
export const isWorkerQrCodeToDataUrlPayloadSuccessPayload = (
  payload: unknown,
): payload is WorkerQrCodeToDataUrlPayloadSuccessPayload => {
  return isRecordUnknown(payload) && payload.type === W_QRCODE_TO_DATA_URL_SUCCESS_MSG
}

export const W_QRCODE_TO_DATA_URL_ERROR_MSG = 'W_QRCODE_TO_DATA_URL_ERROR' as const
export type WorkerQrCodeToDataUrlPayloadErrorPayload = {
  nonce: number
  type: typeof W_QRCODE_TO_DATA_URL_ERROR_MSG
  error: string
}
export const isWorkerQrCodeToDataUrlPayloadErrorPayload = (
  payload: unknown,
): payload is WorkerQrCodeToDataUrlPayloadErrorPayload => {
  return isRecordUnknown(payload) && payload.type === W_QRCODE_TO_DATA_URL_ERROR_MSG
}

export type { QrCodeToDataURLOptions }
